import React from 'react';
import { Star } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
interface TestimonialProps {
  initials: string;
  name: string;
  age: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  age,
  location,
  text
}: TestimonialProps) => <div onClick={scrollToCompra} className="bg-brand-card p-5 rounded-lg border border-brand-accent/30 flex flex-col h-full hover:border-brand-accent transition-colors shadow-[0_4px_20px_rgba(0,0,0,0.5)] cursor-pointer hover:shadow-[0_4px_25px_rgba(34,197,94,0.25)]" data-id="element-254">
    <div className="flex text-brand-accent mb-3" data-id="element-255">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-256" />)}
    </div>
    <p className="text-gray-200 text-xs md:text-sm italic flex-grow leading-relaxed font-medium mb-4" data-id="element-257">
      "{text}"
    </p>
    <div className="flex items-center pt-3 border-t border-white/10" data-id="element-258">
      <div className="w-10 h-10 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-sm mr-3 shrink-0 shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-259">
        {initials}
      </div>
      <div data-id="element-260">
        <p className="font-black text-white text-xs md:text-sm leading-tight" data-id="element-261">
          {name}, <span className="font-bold text-gray-300" data-id="element-262">{age}</span>
        </p>
        <p className="text-[10px] md:text-xs text-brand-accent font-bold" data-id="element-263">
          {location}
        </p>
      </div>
    </div>
  </div>;
export function TestimonialsSection1() {
  return null;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'LM',
    name: 'Laura M.',
    age: '32 años',
    location: 'Ciudad de México, México',
    text: 'Siempre me costaba encontrar material actualizado de educación financiera para secundaria. Este kit tiene todo: desde psicología del dinero hasta proyectos de emprendimiento reales. Los chicos armaron sus propios presupuestos y fue increíble. Me ahorró meses de trabajo.'
  }, {
    initials: 'MR',
    name: 'Martín R.',
    age: '38 años',
    location: 'Bogotá, Colombia',
    text: 'Tengo educación financiera en dos escuelas y antes perdía los fines de semana armando clases. Con este kit abro el PDF y ya tengo todo listo. Las actividades con casos reales y simuladores enganchan a los alumnos desde el primer día.'
  }, {
    initials: 'VS',
    name: 'Valeria S.',
    age: '29 años',
    location: 'Santiago, Chile',
    text: 'Lo mejor son los proyectos integradores. Mis alumnos crearon planes de ahorro e inversión completos con presupuesto, metas y estrategia. Los directivos quedaron impresionados. El material es de otro nivel.'
  }, {
    initials: 'DF',
    name: 'Diego F.',
    age: '45 años',
    location: 'Lima, Perú',
    text: 'Soy docente hace 20 años y nunca encontré algo tan completo para educación financiera. Las rúbricas y evaluaciones me facilitan todo. La planificación anual que viene de bono es un golazo, la presenté tal cual en la institución.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    age: '35 años',
    location: 'Montevideo, Uruguay',
    text: 'Mis alumnos se aburrían con la teoría de siempre. Con las dinámicas de gamificación y los casos reales sobre tarjetas, deudas y criptomonedas ahora participan solos. El kit conecta las finanzas con su vida real y eso hace toda la diferencia.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-brand-accent/10" data-id="element-264">
      <div className="max-w-6xl mx-auto" data-id="element-265">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-266">
          🗨️ Testimonios de Docentes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-267">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-268" />)}
        </div>
      </div>
    </section>;
}